import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "mulebuy-spreadsheet")!;

export default function MulebuySpreadsheetPage() {
  return <BrandArticle data={data} />;
}